import React from "react";
import Reveal from "./Reveal";
import HeroVideo from "./HeroVideo";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden pattern-diagonal"
      data-testid="hero-section"
    >
      <div className="container-edge pt-8 md:pt-10 pb-10 md:pb-14 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 min-h-[60vh]">
        {/* Left typography (60%) */}
        <div className="lg:col-span-7 flex flex-col justify-center">
          <Reveal delay={0}>
            <p className="mono-label-gold mb-5" data-testid="hero-pre-headline">
              THE FULL AI JOURNEY · ONE ECOSYSTEM
            </p>
          </Reveal>

          <h1
            className="font-display text-ink leading-[1.02] tracking-tight"
            data-testid="hero-headline"
            style={{ fontWeight: 500 }}
          >
            <Reveal as="span" delay={80} className="block text-[36px] sm:text-[48px] lg:text-[64px]">
              From your first <em className="italic grad-brand-text" style={{ fontWeight: 400 }}>prompt</em>
            </Reveal>
            <Reveal as="span" delay={200} className="block text-[36px] sm:text-[48px] lg:text-[64px]">
              to your first <em className="italic grad-brand-text" style={{ fontWeight: 400 }}>product</em>
            </Reveal>
            <Reveal as="span" delay={320} className="block text-[36px] sm:text-[48px] lg:text-[64px]">
              to your first <em className="italic" style={{ fontWeight: 400, color: "var(--accent-gold)" }}>round.</em>
            </Reveal>
          </h1>

          <Reveal delay={500}>
            <p
              className="mt-6 text-[16px] md:text-[18px] leading-relaxed max-w-[580px]"
              style={{ color: "var(--ink-secondary)" }}
              data-testid="hero-subhead"
            >
              We don't just teach AI. We train AI practitioners, mentor them as they build,
              connect them to AI jobs, and back the ones who launch companies. For schools,
              colleges, corporates, and you.
            </p>
          </Reveal>

          <Reveal delay={620} className="mt-7 flex flex-col sm:flex-row sm:items-center gap-5">
            <a href="#enquiry" className="btn-primary" data-testid="hero-primary-cta">
              Enquire for Your Context
            </a>
            <a
              href="#ecosystem"
              className="text-[15px] link-underline text-ink-secondary"
              data-testid="hero-secondary-cta"
            >
              Explore the Ecosystem ↓
            </a>
          </Reveal>

          {/* Trust strip — kept light since the Authority Ribbon below carries the heavy load */}
          <Reveal delay={780} className="mt-10">
            <p className="mono-label mb-3">SHIPPED IN 18 MONTHS</p>
            <div className="flex flex-wrap items-center gap-x-8 gap-y-2 max-w-[680px]">
              {[
                "1,000+ practitioners certified",
                "11 launch certifications",
                "70 pods in the inaugural Arena",
                "15 builders being backed",
              ].map((label) => (
                <span
                  key={label}
                  className="text-[12.5px] font-mono"
                  style={{ color: "var(--ink-tertiary)", letterSpacing: "0.06em" }}
                >
                  {label}
                </span>
              ))}
            </div>
          </Reveal>
        </div>

        {/* Right — event recap poster + video modal (replaces abstract orb) */}
        <div className="lg:col-span-5 flex items-center justify-center">
          <Reveal delay={420} className="w-full flex justify-center">
            <HeroVideo />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
